var uniqueCntr = 0;
$.fn.scrolled = function (waitTime, fn) {
   if (typeof waitTime === "function") {
      fn = waitTime;
      waitTime = 60;
   }
   var tag = "scrollTimer" + uniqueCntr++;
   this.scroll(function () {
      var self = $(this);
      var timer = self.data(tag);
      if (timer) {
         clearTimeout(timer);
      }
      timer = setTimeout(function () {
         self.removeData(tag);
         fn.call(self[0]);
      }, waitTime);
      self.data(tag, timer);
   });
};

jQuery(function ($) {
   // Category Page star rating
   if (typeof $.fn.rate !== "undefined")
      $(".star_rating").rate({
         max_value: 5,
         step_size: 0.5,
         initial_value: 0,
         //selected_symbol_type: "utf8_star", // Must be a key from symbols
         selected_symbol_type: "custom_utf8", // Give it a unique name
         symbols: {
            custom_utf8: {
               // Must match selected_symbol_type
               // base: "☆", // Empty star
               base: "★", // Empty star
               hover: "★", // Hover star
               selected: "★", // Selected star
            },
         },
         convert_to_utf8: false,
         cursor: "default",
         readonly: true,
      });

   function showMore() {
      var showChar = 500; // How many characters are shown by default
      var ellipsestext = "...";
      var moretext = "Show More";
      var lesstext = "Show Less";

      $(".read-more").each(function () {
         var content = $(this).html();

         if (content.length > showChar) {
            var c = content.substr(0, showChar);
            c = c.substr(0, Math.min(c.length, c.lastIndexOf(" ")));
            var h = content.substr(c.length, content.length - c.length);

            var html =
               c +
               '<span class="moreellipses">' +
               ellipsestext +
               '&nbsp;</span><span class="morecontent"><span class="content-contain">' +
               h +
               '</span><br /><a href="#" class="morelink ">' +
               moretext +
               "</a></span>";

            $(this).html(html);
         }
      });
   }

   showMore();

   if ($(".page.category").length > 0) {
      var p_height = $(
         ".page.category .category-text-content.truncated div",
      ).height();
      var p_length = $(".page.category .category-text-content.truncated div")
         .text()
         .split(" ");
      p_length = $(p_length).length;
      if (p_height >= 54 && p_length > 50) {
      } else {
         $(".page.category a.read-more").hide();
      }
   }

   $(".page.category a.read-more").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("read-less");
      $(this).parent().find(".category-text-content").toggleClass("truncated");
   });

   if (
      navigator.userAgent.indexOf("Safari") > -1 &&
      navigator.userAgent.indexOf("10.1") > -1
   ) {
      $("body").addClass("safari10");
      $("html").addClass("safari10");
   }

   var global_open = false;

   $(document).on("click", ".global-open", function (e) {
      var target = e.target;
      var target_parent = $(e.target).parent(".global-no-close").length;
      var target_parent_parent = $(e.target)
         .parent()
         .parent(".global-no-close").length;

      if (
         !$(target).is(".global-no-close") &&
         target_parent == 0 &&
         target_parent_parent == 0
      ) {
         $("body").removeClass("global-open");
         $(".global-no-close").removeClass("active");
         $(".global-no-close").removeClass("active");
      }
   });

   function dashLinks() {
      if ($(window).width() <= 960) {
         if ($(".mobile-dash-links-contain").length > 0) {
            return;
         }
         var dash_links_select;
         $(".dashboard-links").each(function () {
            // filter_select += '<option value="'+ $(this).attr('href') +'">'+ $(this).text() + '</option>'
            dash_links_select =
               "<div class='med-contain mobile-dash-links-contain'><div class='mobile-dashboard-links bottommargin-1'><select class='ui-formselect fluid' style='width:100%; margin:0 auto;'><option value='#'> </option>";
            var options = $(this).find("a");

            for (var i = 0; i < options.length; i++) {
               dash_links_select +=
                  '<option value="' +
                  $(options[i]).attr("href") +
                  '">' +
                  $(options[i]).text() +
                  "</option>";
            }

            dash_links_select += "</select></div></div>";

            $(this).hide();
            // $(dash_links_select).insertBefore($(this))
            // if($('[class^="customer-dashboard-"]').length > 0){
            // 	// $('[class^="customer-dashboard-"]').prepend(dash_links_select)

            // }
            // else{
            // 	$(dash_links_select).insertAfter('.dashboard-content .title')
            // 	// $('.customer-dashboard').prepend(dash_links_select)
            // }

            $(dash_links_select).insertAfter(".dashboard-content div.title");
         });
         $(".mobile-dashboard-links .ui-formselect").on("change", function (e) {
            if ($(".mobile-dashboard-links .ui-formselect").val() != "#") {
               location.href = $(".mobile-dashboard-links .ui-formselect").val();
            }
         });
      } else {
         $(".mobile-dash-links-contain").remove();
         $(".dashboard-links").show();
      }
   }
   dashLinks();

   if ($(".category-items").length > 0) {
      if ($(window).width() < 1024) {
         //console.log('ok')

         $(".category-items").each(function () {
            $(this).removeClass("product-list-view");
         });
      }
   }

   if ($(".substitute-items").length > 0) {
      if ($(window).width() < 687) {
         //console.log('ok')

         $(".substitute-items").each(function () {
            $(this).removeClass("product-list-view");
         });
      } else {
         $(".substitute-items").each(function () {
            $(this).addClass("product-list-view");
         });
      }
   }

   //Resize Functions
   var resizeTimer;
   $(window).on("resize", function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
         if ($(window).width() <= 1024) {
            //$("body").removeClass("scrolled");
         }

         if ($(".category-items").length > 0) {
            if ($(window).width() < 1024) {
               $(".category-items").each(function () {
                  $(this).removeClass(".product-list-view");
               });
            }
         }

         if ($(".category-items").length > 0) {
            if ($(window).width() < 1024) {
               //console.log('ok')

               $(".category-items").each(function () {
                  $(this).removeClass("product-list-view");
               });
            }
         }

         if ($(".substitute-items").length > 0) {
            if ($(window).width() < 687) {
               //console.log('ok')

               $(".substitute-items").each(function () {
                  $(this).removeClass("product-list-view");
               });
            } else {
               $(".substitute-items").each(function () {
                  $(this).addClass("product-list-view");
               });
            }
         }

         //Check Link To Select Options

         linksToSelect();
         dashLinks();
      }, 250);
   });

   function checkoutHeaderi5() {
      if ($(window).width() < 330) {
         if ($(".checkout-header").length > 0) {
            var lock = '<i class="icon-lock icon2x"></i>';
            $(".checkout-header").find(".search").empty().append(lock);
         }
      }
   }

   checkoutHeaderi5();

   var cat_index_slider;

   //Enable Ratings
   function linksToSelect() {
      if ($(window).width() <= 1024) {
         if ($(".selectLinks").length > 0) {
            return;
         }
         $(".links-to-select").each(function () {
            var options = [];
            $(this)
               .find("a")
               .each(function () {
                  var option = $(this).text();
                  var option_val = $(this).attr("data-cat");
                  var new_option =
                     '<option val="' + option_val + '">' + option + "</option>";
                  options.push(new_option);
               });

            //options.reverse()

            var linkSelect =
               '<select class="ui-formselect fluid browser-default selectLinks">' +
               options +
               +"</select>";

            $(this).addClass("hidden");
            $(linkSelect).insertBefore($(this));
         });
      } else {
         $(".links-to-select").removeClass("hidden");
         $(".selectLinks").remove();
      }
   }

   linksToSelect();

   // Select all links with hashes
   $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
         // On-page links
         if (
            location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
         ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length
               ? target
               : $("[name=" + this.hash.slice(1) + "]");
            // Does a scroll target exist?
            if (target.length) {
               // Only prevent default if animation is actually gonna happen
               event.preventDefault();
               $("html, body").animate(
                  {
                     scrollTop: target.offset().top,
                  },
                  1000,
                  function () {
                     // Callback after animation
                     // Must change focus!
                     var $target = $(target);
                     $target.focus();
                     if ($target.is(":focus")) {
                        // Checking if the target was focused
                        return false;
                     } else {
                        $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                     }
                  },
               );
            }
         }
      });

   //Header scrolling
   $(window).scrolled(function () {
      var scrolltop = $(window).scrollTop();

      //if($(window).width() > 767){

      if (scrolltop > 120) {
         $(".header").addClass("scrolled");
         //$('.ajax-search-results').addClass('scrolled')
         $("body").addClass("scrolled");
      } else {
         $(".header").removeClass("scrolled");
         //$('.ajax-search-results').removeClass('scrolled')
         // $('.scrolled-nav .category-drop').removeClass('active')
         $("body").removeClass("scrolled");
      }

      if ($(".brands-index-links").length > 0) {
         if (scrolltop > 120) {
            $(".brands-index-links").addClass("scrolled");
         } else {
            $(".brands-index-links").removeClass("scrolled");
         }
      }

      //}

      if ($(".checkout").length > 0) {
         if ($(window).width() > 1024) {
            if (scrolltop > 120) {
               $(".checkout-review").addClass("fixed");
            } else {
               $(".checkout-review").removeClass("fixed");
            }
         }
      }
   });

   $(".show-cat-drop a.first-link").on("click", function (e) {
      e.preventDefault();
      $(".category-drop").addClass("active");
      $(".under-cat-drop").addClass("active");
      $("body").addClass("noscroll");
      $("html").addClass("noscroll");
   });

   $(".under-cat-drop").on("click", function () {
      $(".category-drop").removeClass("active");
      $(this).removeClass("active");
      $("body").removeClass("noscroll");
      $("html").removeClass("noscroll");
   });

   $(".close-sublinks-nav").on("click", function (e) {
      e.preventDefault();
      $(".category-drop").removeClass("active");
      $(".under-cat-drop").removeClass("active");
      $("body").removeClass("noscroll");
      $("html").removeClass("noscroll");
   });

   //Nav hovers

   if ($(window).width() > 960) {
      $(".category-drop .show-sub-links")
         .parent()
         .hover(
            function () {
               $(".category-drop .sub-links").removeClass("active");
               $(this).find(".sub-links").addClass("active");
            },
            function () {
               $(".category-drop .sub-links").removeClass("active");
               // $(this).parent().find('.sub-links').addClass('active')
            },
         );

      $(".filter-contain .filter h3").on("click", function (e) {
         e.preventDefault();
         $(this).toggleClass("open");
         $(this).parent().find(".filter-options").slideToggle();
      });
   } else {
      $(".filter-contain .filter h3").on("click", function (e) {
         e.preventDefault();
         $(this).toggleClass("open");
         $(this).parent().find(".filter-options").slideToggle();
      });
   }

   $(".show-sub-links").on("click", function (e) {
      if ($(window).width() <= 960) {
         e.preventDefault();
         $(this).parent().find(".sub-links").slideToggle();
      }
   });
   /* $('.search-icon').on('click', function(e){
       if($(window).width() <= 1024){
          e.preventDefault();
          $('.mobile-search').toggleClass('active')
       }
    }) */

   $(".scrolled-nav-toggle").on("click", function (e) {
      e.preventDefault();
      // $('.category-drop').addClass('active')
      // $(this).parent().find('.category-drop').toggleClass('active')

      if ($(window).scroll() > 960) {
         // alert('here')
         $(".category-drop").addClass("active");
         $(".under-cat-drop").addClass("active");
         $("body").addClass("noscroll");
         $("html").addClass("noscroll");
      } else {
         console.log("else", $(this).parent().find(".category-drop"));
         $(".category-drop").addClass("active");
         $(".under-cat-drop").addClass("active");
         // $('body').addClass('noscroll')
         // $('html').addClass('noscroll')
      }
   });

   $(".brands-drop-link").hover(
      function () {
         $(".brands-drop").addClass("active");
         $("body").addClass("noscroll");
         $("html").addClass("noscroll");
      },
      function () {
         $(".brands-drop").removeClass("active");
         $("body").removeClass("noscroll");
         $("html").removeClass("noscroll");
      },
   );

   $(".letter-link").on("click", function (e) {
      e.preventDefault();
      var letter_link = $(this).attr("data-letter-link");
      var target_letter = $(
         '.letter-group[data-letter-index="' + letter_link + '"]',
      );

      var header_height = $(".header").height();
      // var target_letter = document.querySelectorAll("[data-letter-index='b']");
      var distance = $(target_letter).offset().top;
      distance = distance - header_height - 24;
      distance = distance + $(".brands-drop .sublinks").scrollTop();

      $(".brands-drop .sublinks").animate(
         {
            scrollTop: distance,
         },
         "fast",
      );
   });

   var searchTimer; //timer identifier
   var searchInt = 200; //time in ms, 5 second for example
   var search_val = "";
   var searchInput = $("#header_search");

   $(searchInput).on("keyup", function () {
      search_val = $(this).val();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
         if (search_val.length > 2) {
            $.ajax({
               url: "index.php?route=common/essearch/search&search=" + search_val,
               dataType: "json",
               beforeSend: function () {
                  //$('.e-search-outer').removeClass('active')
               },
               complete: function () { },
               success: function (response) {
                  if (response.success == true) {
                     html = "";
                     cat_html = "";
                     total_html = "";
                     if (response.data) {
                        if (response.data.products) {
                           $.each(response.data.products, function (index, value) {
                              html += "<li>";
                              html +=
                                 '<a href="' +
                                 value.href +
                                 '" class="img"><img src="' +
                                 value.thumb +
                                 '" alt="' +
                                 value.name +
                                 '"></a>';
                              html += '<div class="sl-right">';
                              if (value.badge != "") {
                                 html += '<div class="badges">' + value.badge + "</div>";
                              }
                              html +=
                                 '<p><a href="' +
                                 value.href +
                                 '">' +
                                 value.name +
                                 '</a></p><div class="sl-right-bottom"><p>';
                              html += value.price_html;
                              html += "</p>";
                              html += value.button_html;
                              html += "</div></div></li>";
                           });
                        }
                        if (response.data.categories) {
                           $.each(response.data.categories, function (index, value) {
                              cat_html +=
                                 '<a href="' +
                                 value.category_url +
                                 '" class="tile"><font>' +
                                 value.name +
                                 "</font></a>";
                           });
                        }
                        if (response.total) {
                           total_html = response.total + " results";
                        }
                     }
                     if (cat_html) {
                        cat_html = "<h2>" + cat_html + "</h2>";
                        $(".header .hed_desktop .hed_search_pro_top_left_content").html(
                           cat_html,
                        );
                        $(".header .hed_desktop .hed_search_pro_top_left").removeClass(
                           "tl_hide",
                        );
                        $(".header .hed_desktop .hed_search_pro_top_right").removeClass(
                           "tl_hide",
                        );
                     } else {
                        cat_html = "";
                        $(".header .hed_desktop .hed_search_pro_top_left").addClass(
                           "tl_hide",
                        );
                        $(".header .hed_desktop .hed_search_pro_top_right").addClass(
                           "tl_hide",
                        );
                        $(".header .hed_desktop .hed_search_pro_top_left_content").html(
                           cat_html,
                        );
                     }
                     if (html) {
                        //console.log(html);
                        html = "<ul>" + html + "</ul>";
                        $(".header .hed_desktop .hed_search_pro_top_right").html(html);

                        $(".header .hed_desktop .hed_search_pro .add-btn-hp").on(
                           "click",
                           function (e) {
                              e.preventDefault();
                              $(this).html("Processing...");
                              var product_id = $(this).attr("data-product-id");
                              var qty = $(this).attr("data-product-min");
                              cart.add(product_id, qty);
                           },
                        );
                        $(".header .hed_desktop .hed_search_pro .notify-btn-hp").on(
                           "click",
                           function (e) {
                              e.preventDefault();
                              var product_id = this.getAttribute("data-product-id");
                              $("#notify-modal .content .form #notify_product_id").val(
                                 product_id,
                              );
                              $("#notify-modal .content .form").show();
                              $("#notify-modal .content .success").hide();
                              $("#notify-modal").iziModal("open");
                           },
                        );
                     } else {
                        html =
                           '<p style="padding:0 0 25px 25px;">Sorry! There were no exact matches for your search. Please double-check that all terms were spelled correctly or try again with different keywords. Please contact us at 1-877-873-1336 or customerservice@zoolie.com for further assistance.</p>';
                        $(".header .hed_desktop .hed_search_pro_top_right").html(html);
                     }
                     if (total_html) {
                        $(
                           ".header .hed_desktop .hed_search_pro_top_botm .results",
                        ).html(total_html);
                     } else {
                        total_html = "0 results";
                        $(
                           ".header .hed_desktop .hed_search_pro_top_botm .results",
                        ).html(total_html);
                     }
                     $(
                        ".header .hed_desktop .hed_search_pro_top_botm #search_form_submit",
                     ).attr(
                        "href",
                        "/search?search=" + encodeURIComponent(search_val),
                     );

                     $("body").addClass("change-bg");
                     $("body").addClass("noscroll");
                     $("html").addClass("noscroll");
                     $(".search").addClass("active");
                     $(".header .hed_desktop .hed_search_pro").show();
                  }
               },
            });
         } else {
            $(".header .hed_desktop .hed_search_pro").hide();
            $("body").removeClass("change-bg");
            $("body").removeClass("noscroll");
            $("html").removeClass("noscroll");
            $(".search").removeClass("active");
         }
      }, searchInt);
   });

   $("input#header_search").click(function () {
      //console.log("clicked here");
      search_val = $(this).val();
      if (search_val.length > 2) {
         $("body").addClass("change-bg");
         $("body").addClass("noscroll");
         $("html").addClass("noscroll");
         $(".search").addClass("active");
         $(".header .hed_desktop .hed_search_pro").show();
      } else {
         $(".header .hed_desktop .hed_search_pro").hide();
         $("body").removeClass("change-bg");
         $("body").removeClass("noscroll");
         $("html").removeClass("noscroll");
         $(".search").removeClass("active");
      }
   });

   // $(document).mouseup(function(e){
   // 	var container = $('.header .top');
   // 	if(!container.is(e.target) && container.has(e.target).length === 0){
   // 		//console.log("closed here");
   // 		$(".header .hed_desktop .hed_search_pro").hide();
   // 		$(".header .hed_mobile .hed_search_pro").hide();
   // 		$('body').removeClass('change-bg');
   // 		$('body').removeClass('noscroll');
   // 		$('html').removeClass('noscroll');
   // 	}
   // });

   var searchTimer; //timer identifier
   var searchInt = 200; //time in ms, 5 second for example
   var search_val = "";
   var searchInput = $("#header_search_m");

   $(searchInput).on("keyup", function () {
      search_val = $(this).val();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
         if (search_val.length > 2) {
            $.ajax({
               url: "index.php?route=common/essearch/search&search=" + search_val,
               dataType: "json",
               beforeSend: function () {
                  //$('.e-search-outer').removeClass('active')
               },
               complete: function () { },
               success: function (response) {
                  if (response.success == true) {
                     html = "";
                     cat_html = "";
                     total_html = "";
                     if (response.data) {
                        if (response.data.products) {
                           $.each(response.data.products, function (index, value) {
                              html += "<li>";
                              html +=
                                 '<a href="' +
                                 value.href +
                                 '" class="img"><img src="' +
                                 value.thumb +
                                 '" alt="' +
                                 value.name +
                                 '"></a>';
                              html += '<div class="sl-right">';
                              if (value.badge != "") {
                                 html += '<div class="badges">' + value.badge + "</div>";
                              }
                              html +=
                                 '<p><a href="' +
                                 value.href +
                                 '">' +
                                 value.name +
                                 '</a></p><div class="sl-right-bottom"><p>';
                              html += value.price_html;
                              html += "</p>";
                              html += value.button_html;
                              html += "</div></div></li>";
                           });
                        }
                        if (response.data.categories) {
                           $.each(response.data.categories, function (index, value) {
                              cat_html +=
                                 '<a href="' +
                                 value.category_url +
                                 '" class="tile"><font>' +
                                 value.name +
                                 "</font></a>";
                           });
                        }
                        if (response.total) {
                           total_html = response.total + " results";
                        }
                     }
                     if (cat_html) {
                        cat_html = "<h2>" + cat_html + "</h2>";
                        $(".header .hed_mobile .hed_search_pro_top_left_content").html(
                           cat_html,
                        );
                        $(".header .hed_mobile .hed_search_pro_top_left").removeClass(
                           "tl_hide",
                        );
                        $(".header .hed_mobile .hed_search_pro_top_right").removeClass(
                           "tl_hide",
                        );
                     } else {
                        cat_html = "";
                        $(".header .hed_mobile .hed_search_pro_top_left").addClass(
                           "tl_hide",
                        );
                        $(".header .hed_mobile .hed_search_pro_top_right").addClass(
                           "tl_hide",
                        );
                        $(".header .hed_mobile .hed_search_pro_top_left_content").html(
                           cat_html,
                        );
                     }
                     if (html) {
                        //console.log(html);
                        html = "<ul>" + html + "</ul>";
                        $(".header .hed_mobile .hed_search_pro_top_right").html(html);

                        $(".header .hed_mobile .hed_search_pro .add-btn-hp").on(
                           "click",
                           function (e) {
                              e.preventDefault();
                              $(this).html("Processing...");
                              var product_id = $(this).attr("data-product-id");
                              var qty = $(this).attr("data-product-min");
                              cart.add(product_id, qty);
                           },
                        );
                        $(".header .hed_mobile .hed_search_pro .notify-btn-hp").on(
                           "click",
                           function (e) {
                              e.preventDefault();
                              var product_id = this.getAttribute("data-product-id");
                              $("#notify-modal .content .form #notify_product_id").val(
                                 product_id,
                              );
                              $("#notify-modal .content .form").show();
                              $("#notify-modal .content .success").hide();
                              $("#notify-modal").iziModal("open");
                           },
                        );
                     } else {
                        html =
                           '<p style="padding:0 0 25px 25px;">Sorry! There were no exact matches for your search. Please double-check that all terms were spelled correctly or try again with different keywords. Please contact us at 1-877-873-1336 or customerservice@zoolie.com for further assistance.</p>';
                        $(".header .hed_mobile .hed_search_pro_top_right").html(html);
                     }
                     if (total_html) {
                        $(".header .hed_mobile .hed_search_pro_top_botm .results").html(
                           total_html,
                        );
                     } else {
                        total_html = "0 results";
                        $(".header .hed_mobile .hed_search_pro_top_botm .results").html(
                           total_html,
                        );
                     }
                     $(
                        ".header .hed_mobile .hed_search_pro_top_botm #search_form_submit",
                     ).attr(
                        "href",
                        "/search?search=" + encodeURIComponent(search_val),
                     );

                     $("body").addClass("change-bg");
                     $("body").addClass("noscroll");
                     $("html").addClass("noscroll");
                     $(".search").addClass("active");
                     $(".header .hed_mobile .hed_search_pro").show();
                  }
               },
            });
         } else {
            $(".header .hed_mobile .hed_search_pro").hide();
            $("body").removeClass("change-bg");
            $("body").removeClass("noscroll");
            $("html").removeClass("noscroll");
            $(".search").removeClass("active");
         }
      }, searchInt);
   });

   $("input#header_search_m").click(function () {
      search_val = $(this).val();
      if (search_val.length > 2) {
         $("body").addClass("change-bg");
         $("body").addClass("noscroll");
         $("html").addClass("noscroll");
         $(".search").addClass("active");
         $(".header .hed_mobile .hed_search_pro").show();
      } else {
         $(".header .hed_mobile .hed_search_pro").hide();
         $("body").removeClass("change-bg");
         $("body").removeClass("noscroll");
         $("html").removeClass("noscroll");
         $(".search").removeClass("active");
      }
   });

   /* $(document).mouseup(function(e){
       var container = $('.header .top .hed_mobile');
       if(!container.is(e.target) && container.has(e.target).length === 0){
          $(".header .hed_mobile .hed_search_pro").hide();
          $('body').removeClass('change-bg');
          $('body').removeClass('noscroll');
          $('html').removeClass('noscroll');
       }
    }); */

   //GLOBAL FUNCS
   function ellipsizeTextBox() {
      function last_word(elem) {
         //var d = document.getElementById('flop');
         var d = elem;
         var t = d.innerHTML;
         var w = t.split(" ");

         d.innerHTML = w[0];
         var height = d.clientHeight;
         for (var i = 1; i < w.length; i++) {
            d.innerHTML = d.innerHTML + " " + w[i];

            if (d.clientHeight > height) {
               height = d.clientHeight;
               //console.log(w[i-1]);
               // $(w[i-1]).wrap('<div class="wooooo" />')
            }
         }
      }

      $("[data-trim-lines]").each(function () {
         var line_height = $(this).css("line-height");
         var lines_trim = $(this).attr("data-trim-lines");
         var max_height = parseInt(line_height) * parseInt(lines_trim);
         $(this).css({
            "max-height": max_height,
            overflow: "hidden",
         });

         last_word(this);
      });
   }
   ellipsizeTextBox();
   

   $(".configurable-dropdown .selected-option a").on("click", function (e) {
      e.preventDefault();
      $(".configurable-dropdown .options").toggleClass("active");

      $("body").addClass("global-open");
   });

   $("#button-notify").on("click", function (e) {
      e.preventDefault();
      var product_id = this.getAttribute("data-product-id");
      $("#notify-modal .content .form #notify_product_id").val(product_id);
      $("#notify-modal .content .form").show();
      $("#notify-modal .content .success").hide();
      $("#notify-modal").iziModal("open");
   });
   $("#button-notify-float").on("click", function (e) {
      e.preventDefault();
      var product_id = this.getAttribute("data-product-id");
      $("#notify-modal .content .form #notify_product_id").val(product_id);
      $("#notify-modal .content .form").show();
      $("#notify-modal .content .success").hide();
      $("#notify-modal").iziModal("open");
   });

   $(document).on(
      "click",
      ".crosssell-slider .product .add-cart-link",
      function (e) {
         e.preventDefault();

         var atc_text = $(this).text();
         var item_id = $(this).attr("data-item-id");
         var item_mpn = $(this).attr("data-item-mpn");
         var item_name = $(this).attr("data-item-name");
         var item_min = $(this).attr("data-item-min");
         var item_title = $(this).parent().find(".product-title").text();
         var item_desc = $(this).attr("data-item-desc");
         var item_img = $(this).parent().find(".image img").attr("src");
         var item_href = $(this).parent().find(".image").attr("href");

         if (atc_text == "Notify") {
            atc_text = "Notify When Available";
            $("#cross-sell-modal #cross-sell-atc").hide();
            $("#cross-sell-modal #cross-sell-notify-atc").show();
            $("#cross-sell-modal").find(".pop-image").attr("href", item_href);
            $("#cross-sell-modal").find(".pop-image").attr("title", item_title);
            $("#cross-sell-modal").find(".pop-image img").attr("src", item_img);
            $("#cross-sell-modal").find(".section-title-sm").text(item_title);
            $("#cross-sell-modal")
               .find(".section-title-sm")
               .attr("href", item_href);
            $("#cross-sell-modal")
               .find(".section-title-sm")
               .attr("title", item_title);
            $("#cross-sell-modal").find(".short-desc").text(item_desc);
            $("#cross-sell-modal")
               .find(".notify-btn")
               .attr("data-item-id", item_id);
            $("#cross-sell-modal")
               .find(".notify-btn")
               .attr("data-product-id", item_id);
            $("#cross-sell-modal")
               .find(".notify-btn")
               .attr("data-item-mpn", item_mpn);
            $("#cross-sell-modal")
               .find(".notify-btn")
               .attr("data-item-name", item_name);
            $("#cross-sell-modal")
               .find(".notify-btn")
               .attr("data-item-min", item_min);
            $("#cross-sell-modal").find(".notify-btn").text(atc_text);
         } else {
            $("#cross-sell-modal #cross-sell-atc").show();
            $("#cross-sell-modal #cross-sell-notify-atc").hide();
            $("#cross-sell-modal").find(".pop-image").attr("href", item_href);
            $("#cross-sell-modal").find(".pop-image").attr("title", item_title);
            $("#cross-sell-modal").find(".pop-image img").attr("src", item_img);
            $("#cross-sell-modal").find(".section-title-sm").text(item_title);
            $("#cross-sell-modal")
               .find(".section-title-sm")
               .attr("href", item_href);
            $("#cross-sell-modal")
               .find(".section-title-sm")
               .attr("title", item_title);
            $("#cross-sell-modal").find(".short-desc").text(item_desc);
            $("#cross-sell-modal").find(".add-btn").attr("data-item-id", item_id);
            $("#cross-sell-modal").find(".add-btn").attr("data-item-mpn", item_mpn);
            $("#cross-sell-modal")
               .find(".add-btn")
               .attr("data-item-name", item_name);
            $("#cross-sell-modal").find(".add-btn").attr("data-item-min", item_min);
            $("#cross-sell-modal").find(".add-btn").text(atc_text);
         }

         $(".cross-sell-add-modal").iziModal("open");
      },
   );

   function hasOpenIziModal() {
      return $(".iziModal").filter(function () {
         var modal = $(this).data("iziModal");

         if (modal) {
            var state = $(this).iziModal("getState");

            return state == "opening" || state == "opened";
         }

         return $(this).is(":visible");
      }).length > 0;
   }

   function updateIziModalBodyScroll() {
      $("body").toggleClass("noscroll", hasOpenIziModal());
   }

   function blurFocusedIziModalDescendant($modal) {
      var activeElement = document.activeElement;

      if (
         activeElement &&
         activeElement !== document.body &&
         $modal[0].contains(activeElement) &&
         typeof activeElement.blur === "function"
      ) {
         activeElement.blur();
      }
   }

   function rememberIziModalTrigger($modal) {
      var activeElement = document.activeElement;

      if (
         activeElement &&
         activeElement !== document.body &&
         !$modal[0].contains(activeElement)
      ) {
         $modal.data("iziModalTrigger", activeElement);
      }
   }

   function restoreIziModalTrigger($modal) {
      var trigger = $modal.data("iziModalTrigger");

      $modal.removeData("iziModalTrigger");

      if (
         trigger &&
         document.contains(trigger) &&
         typeof trigger.focus === "function" &&
         $(trigger).is(":visible") &&
         !$(trigger).is(":disabled") &&
         !hasOpenIziModal()
      ) {
         trigger.focus();
      }
   }

   $(document)
      .off(".iziModalFocusFix")
      .on("opening.iziModalFocusFix", ".iziModal", function () {
         rememberIziModalTrigger($(this));
      })
      .on("opening.iziModalFocusFix opened.iziModalFocusFix", ".iziModal", function () {
         $("body").addClass("noscroll");
      })
      .on("closing.iziModalFocusFix", ".iziModal", function () {
         blurFocusedIziModalDescendant($(this));
         setTimeout(updateIziModalBodyScroll, 0);
      })
      .on("closed.iziModalFocusFix", ".iziModal", function () {
         restoreIziModalTrigger($(this));
         setTimeout(updateIziModalBodyScroll, 0);
      });

   $(".modal").iziModal();

   $(".show-review-form").on("click", function () {
      var mpn = $(this).attr("data-mpn");
      var link =
         "https://digital.essendant.com/reviewsadmin/createreview?apiToken=eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIiwiY3R5IjoiSldUIn0..aGrgxxlsxqnMyf61Ob80EQ.4cO3eXxVpQuR1ZABEGQhcQl6a1qJMzB-2POrOEVzY7dSyTh72bvnMKiWiOfp4YnEPE7MkiJ16mUP9wplKxx4YFsYaf7NxUQQydsGCXVG9DsgjJb_sWUd_j_Ru3yzO-mltRIIrHm8bi87F_dGadLmRuRccNT-rjhQy2M6WA3HVs6NZ7R1MrEojQ_5Dyub7xeZhLtx5rZKsI1-_8YU_XNojhatFQOJqw7PGUNS5U0JuwolpOlDKJUQnT7GasSHPJWr6DMlsQu4B16UG-cXYDW6jwuN7f9-8fUWF4qUVJWMX2Ast5o6_3ePEaYCBHOl6nUzIkCnU8gjaiYZJAA2L8e27NH0wzjUkAbhjsQf_i06KxPi9-iPlMYkLeE85e7qFwsvdy5tHMeBqP7E7ZSVKvdqgFR67Ltk-yn-gmN_fN87IMySuxyFckRgwR8YQx75zZAg4hY3jKJzptIHtPGTWPiFZzppba91HFYbTqUqkH0_fXrsQxifQl_cO2KejNEWa2O77hrRSqKYrhGuT21_zCzPAobsYF96iKGj_jKuXgROtL_ALH90zfASZXU8g02dnsd2ZbBWezF2pPw3BEFkTk7wow5JBTm9t-UuK7iTPH1jQWUx6AUk9V6aWrwm2QNgjpp5bqt08Ic6ATIVSUdx6x61tWAQo3NokkBNfQrQo9kY44fAkg6nbNC9O1RQh_1IyUisGZhxJ7sx9LRvzQanUUOO43KznajVj1pP1JLixECXLwB8xtbJfzisgpyu7TdT3SO4.aX_h38fghKSUOg6-RdlzrA&itemNum=" +
         mpn +
         "&guestUser=Y&DAReportID=TEST";
      html =
         '<iframe src="' +
         link +
         '" class="iziModal-iframe" style="height:500px;"></iframe>';
      $("#review-modal .content").html(html);
      $("#review-modal").iziModal("open");
   });

   $(".toggle-specs").on("click", function (e) {
      e.preventDefault();
      $(".specs-toggle-items").slideToggle();
   });

   $(".toggles a").hover(
      function () {
         if ($(window).width() > 1023) {
            $(this).addClass("hover-off");
         }
      },
      function () {
         $(this).removeClass("hover-off");
      },
   );

   $(".toggles a").on("click", function (e) {
      if ($(window).width() > 1023) {
         e.preventDefault();
         $(".toggles a").addClass("off");
         $(this).removeClass("off");

         if ($(this).hasClass("list-view")) {
            $(".category-items").addClass("product-list-view");
         } else {
            $(".category-items").removeClass("product-list-view");
         }
      }
   });

   $(".qty-input .qty-change").on("click", function (e) {
      e.preventDefault();

      var new_qty;
      var cur_qty = parseInt($(".qty").val());

      if ($(this).hasClass("decrease-qty")) {
         if (cur_qty == 1) {
         } else {
            new_qty = cur_qty - 1;
            $(".qty").val(new_qty);
         }
      } else if ($(this).hasClass("increase-qty")) {
         new_qty = cur_qty + 1;
         $(".qty").val(new_qty);
      } else {
         $(".qty").val(1);
      }
   });

   $(".product-add__add .scoot_product_rit .number .change-qty").on(
      "click",
      function (e) {
         e.preventDefault();

         var new_qty;
         var cur_qty = parseInt(
            $(".product-add__add .scoot_product_rit .number .qty").val(),
         );

         if ($(this).hasClass("minus")) {
            if (cur_qty == 1) {
            } else {
               new_qty = cur_qty - 1;
               $(".product-add__add .scoot_product_rit .number .qty").val(new_qty);
            }
         } else if ($(this).hasClass("plus")) {
            new_qty = cur_qty + 1;
            $(".product-add__add .scoot_product_rit .number .qty").val(new_qty);
         } else {
            $(".product-add__add .scoot_product_rit .number .qty").val(1);
         }
      },
   );

   $(".product-add__add .bottom .number .change-qty").on("click", function (e) {
      e.preventDefault();

      var new_qty;
      var cur_qty = parseInt($(".product-add__add .bottom .number .qty").val());

      if ($(this).hasClass("minus")) {
         if (cur_qty == 1) {
         } else {
            new_qty = cur_qty - 1;
            $(".product-add__add .bottom .number .qty").val(new_qty);
         }
      } else if ($(this).hasClass("plus")) {
         new_qty = cur_qty + 1;
         $(".product-add__add .bottom .number .qty").val(new_qty);
      } else {
         $(".product-add__add .bottom .number .qty").val(1);
      }
   });

   $(".atc_add .scoot_product_rit .number .change-qty").on(
      "click",
      function (e) {
         e.preventDefault();

         var new_qty;
         var cur_qty = parseInt(
            $(".atc_add .scoot_product_rit .number .qty_product_value").val(),
         );

         if ($(this).hasClass("minus")) {
            if (cur_qty == 1) {
            } else {
               new_qty = cur_qty - 1;
               $(".atc_add .scoot_product_rit .number .qty_product_value").val(
                  new_qty,
               );
            }
         } else if ($(this).hasClass("plus")) {
            new_qty = cur_qty + 1;
            $(".atc_add .scoot_product_rit .number .qty_product_value").val(
               new_qty,
            );
         } else {
            $(".atc_add .scoot_product_rit .number .qty_product_value").val(1);
         }
      },
   );

   //Line Check

   //Supplies tabs
   $(".tabs .tab").on("click", function (e) {
      e.preventDefault();
      $(this).parent().find(".tab").removeClass("active");
      $(this).addClass("active");

      var tab_id = $(this).attr("data-tab-show");
      change_tabs(tab_id);
   });

   function change_tabs(elem) {
      $('.tab-section[data-tab-section="' + elem + '"]')
         .parent()
         .find(".tab-section")
         .removeClass("active");
      $('.tab-section[data-tab-section="' + elem + '"]').addClass("active");

      tabs_block_height(elem);
      //$('.tab-section[data-tab-section="'+ elem +'"]')
   }

   function tabs_block_height(elem) {
      if (elem) {
         //console.log('aysdhasd')
         var new_height =
            $('.tab-section[data-tab-section="' + elem + '"]').height() + 30;
         $('.tab-section[data-tab-section="' + elem + '"]')
            .parent()
            .css("height", new_height);
      } else {
         $(".tabs-block").each(function () {
            var tallest_sec = 0;

            var active_height = $(this).find(".tab-section.active").height();
            // $(this).find('.tab-section').each(function(){
            // 	if($(this).height() > tallest_sec){
            // 		tallest_sec = $(this).height()
            // 	}
            // })

            var new_height = active_height + 30;
            $(this).css("height", new_height);
         });
      }
   }

   tabs_block_height();

   //checkout related
   $(".change-payment-method").on("click", function (e) {
      e.preventDefault();
      $(".saved-methods").slideToggle(250);
      $(".saved-payment-info").slideUp();
   });

   $(".add-payment-method").on("click", function (e) {
      e.preventDefault();
      $(".add-payment-method-step").slideToggle(250);
      $(".add-payment-method-address-step").slideToggle(250);
      $(".saved-payment-info").slideUp();
   });

   $(".add-shipping-address").on("click", function (e) {
      e.preventDefault();
      $(".add-shipping-address-step").slideToggle(250);
      $(".saved-address-info").slideUp();
   });

   $(".change-shipping-address").on("click", function (e) {
      e.preventDefault();
      $(".change-shipping-address-step").slideToggle(250);
      $(".saved-address-info").slideUp();
   });

   $(".close-address-change").on("click", function (e) {
      e.preventDefault();
      $(".change-shipping-address-step").slideUp(250);
      $(".add-payment-method-address-step").slideUp(250);
      $(".add-shipping-address-step").slideUp(250);
      $(".saved-address-info").slideDown();
   });

   $(".close-payment").on("click", function (e) {
      e.preventDefault();
      $(".add-payment-method-step").slideUp(250);
      $(".add-payment-method-address-step").slideUp(250);
      $(".saved-methods").slideUp(250);
      $(".saved-payment-info").slideDown();
   });

   //Ink Form
   var next, prev, parent;

   $(".ink-form .ui-formselect.active a").on("click", function (e) {
      e.preventDefault();

      parent = $(this).parent().parent();

      next = $(parent).nextAll(".proper_select").first();
      next_all = $(parent).nextAll(".proper_select");
      prev = $(this).parent().parent().prev(".ui-formselect.active");

      console.log($(this).attr("data-val"));

      if ($(this).parent().hasClass("disabled")) {
         return;
      }

      if ($(this).attr("data-val") == "#") {
         $(next_all).addClass("disabled");
      } else {
         $(next).removeClass("disabled");
         if ($(parent).attr("data-sel-el") == "printer_brand") {
            '.ui-formselect[data-sel-el="printer_model"]'.addClass("disabled");
         }
      }

      if (
         $(parent).attr("data-sel-el") == "printer_brand" &&
         $(this).attr("data-val") == "#"
      ) {
         $('.ui-formselect[data-sel-el="printer_series"]').addClass("disabled");
         $('.ui-formselect[data-sel-el="printer_model"]').addClass("disabled");
      }
   });

   function update_ink_form(input_id) {
      //Conditon to check for any select changed and append to option label
      if (input_id == "printer_brand") {
         var label_val = "Select Printer Series";
         var type = "series";
         var brand_id = $(".ui-formselect#printer_brand").val();
         var series_id = 0;
      } else if (input_id == "printer_series") {
         var label_val = "Select Printer Model";
         var type = "model";
         var brand_id = $(".ui-formselect#printer_brand").val();
         var series_id = $(".ui-formselect#printer_series").val();
      }

      //This is a temporary exmaple for the success response
      var all_options =
         '<option value="#">' +
         label_val +
         '</option><option value="2630">Epson WorkForce® 2630</option><option value="AX4402">AX4402</option><option value="CE130">CE130</option><option value="EP4140">EP4140</option>';

      //This is how you could handle the response to replace the options
      next = $("#" + input_id)
         .nextAll(".ui-formselect")
         .first();
      prev = $("#" + input_id).prev(".ui-formselect");

      //$(next).empty().append(all_options)

      //HERE IS AN ACTUAL AJAX REQUEST, THE ABOVE CODE CAN GO WIHTIN THE SUCCESS CALLBACK
      $.ajax({
         type: "GET",
         url: "/index.php?route=module/ink_toner_finder/ajax",
         data: {
            type: type,
            brand: brand_id,
            series: series_id,
         },
         // beforeSend:function(){
         // any sort of loading/before handling you want to use
         // },
         success: function (data) {
            // successful request; do something with the data
            $(next).empty().append(data);
         },
         // error:function(){
         // failed request; give feedback to user
         // }
      });
   }

   $(".ink-form .ui-formselect").on("change", function (e) {
      e.preventDefault();

      next = $(this).nextAll(".ui-formselect").first();
      next_all = $(parent).nextAll(".proper_select");
      prev = $(this).prev(".ui-formselect");

      if ($(this).hasClass("disabled")) {
         return;
      }

      if ($(this).val() == "#") {
         //THIS MEANS A NON OPTION HAS BEEN SELECTED
         $(next).addClass("disabled");
      } else {
         //THIS IS A SUCCESSFUL NEXT STEP
         if ($(this).attr("id") == "printer_brand") {
            $(".ui-formselect#printer_model")
               .val($("#printer_model option:first").val())
               .addClass("disabled");
         }
         $(next).removeClass("disabled");
         if ($(this).attr("id") == "printer_model") {
            location.href = $(this).val();
         } else {
            update_ink_form($(this).attr("id"));
         }
      }

      if ($(this).attr("id") == "printer_brand" && $(this).val() == "#") {
         //THIS MEANS THE FIRST OPTION HAS BEEN RESET SO OTHER OPTIONS MUST RESET.  FOR AJAX YOU MAY WANT TO USE EMPTY INSTEAD OF VAL()
         $(".ui-formselect#printer_series")
            .val($("#printer_series option:first").val())
            .addClass("disabled");
         $(".ui-formselect#printer_model")
            .val($("#printer_model option:first").val())
            .addClass("disabled");
      }

      ///PLACE AJAX HERE
   });

   var ink_timer,
      ink_delay = 500;
   var ink_search_val = "";

   $("#brands-search-filter").on("keyup", function () {
      ink_search_val = $(this).val().toLowerCase();
      clearTimeout(ink_timer);

      ink_timer = setTimeout(function () {
         //console.log(ink_search_val)

         if (ink_search_val.length > 0) {
            //FILTER
            $(".brand-tabs-sections .tab-section.active .brand").each(function () {
               //Make sure there's a brand name
               if (this.hasAttribute("data-brand-name")) {
                  var brand_name = $(this).attr("data-brand-name");
               } else {
                  var brand_name = "none";
               }

               //Check if search matches brands
               if (brand_name.includes(ink_search_val)) {
                  //console.log(brand_name)
                  $(this).fadeIn(300);
               } else {
                  var elem = $(this);
                  $(elem).fadeOut(500, function () {
                     $(elem).hide();
                  });
               }
            });
         } else {
            //REMOVE FILTERS
            $(".brand-tabs-sections .tab-section.active .brand").show();
         }
      }, ink_delay);
   });

   var ink_model_timer,
      ink_model_delay = 500;
   var ink_model_search_val = "";

   $("#models-search-filter").on("keyup", function () {
      ink_model_search_val = $(this).val().toLowerCase();
      clearTimeout(ink_model_timer);

      ink_model_timer = setTimeout(function () {
         //console.log(ink_search_val)

         if (ink_model_search_val.length > 0) {
            //FILTER
            $(".brand-tabs-sections .tab-section.active .brand-links").each(
               function () {
                  //Make sure there's a brand name
                  if (this.hasAttribute("data-brand-name")) {
                     var model_name = $(this).attr("data-brand-name");
                  } else {
                     var model_name = "none";
                  }

                  //Check if search matches brands
                  if (model_name.includes(ink_model_search_val)) {
                     //console.log(brand_name)
                     $(this).fadeIn(300);
                  } else {
                     var elem = $(this);
                     $(elem).fadeOut(500, function () {
                        $(elem).hide();
                     });
                  }
               },
            );
         } else {
            //REMOVE FILTERS
            $(".brand-tabs-sections .tab-section.active .brand-links").show();
         }
      }, ink_model_delay);
   });

   var model_search_timer,
      model_search_delay = 500;
   var model_search_val = "";

   $("#model_number").on("keyup", function () {
      model_search_val = $(this).val();
      clearTimeout(model_search_timer);

      model_search_timer = setTimeout(function () {
         if (model_search_val.length >= 2) {
            $.ajax({
               url:
                  "/index.php?route=module/ink_toner_finder/autocomplete&filter_type=autocomplete&filter_name=" +
                  model_search_val,
               dataType: "json",
               beforeSend: function () {
                  $(".model-number-autocomplete").removeClass("active");
               },
               complete: function () { },
               success: function (response) {
                  //console.log(response);
                  html = "";
                  $.each(response, function (index, value) {
                     html +=
                        '<a href="' + value.url + '" class="item flex items-center">';
                     html += '<div class="details">';
                     html += "<p>";
                     html += value.name;
                     html += "</p>";
                     html += "</div>";
                     html += "</a>";
                  });
                  if (html == "") {
                     html =
                        '<div class="item flex items-center"><div class="details"><p>Sorry! There Were No Matching Results.</p></div></div>';
                  }
                  if (html) {
                     //console.log(html);
                     $(".model-number-autocomplete").html(html);
                     $(".model-number-autocomplete").addClass("active");
                  }
               },
            });
         } else {
            //REMOVE FILTERS
            $(".model-number-autocomplete").removeClass("active");
         }
      }, model_search_delay);
   });

   $("#model_number").blur(function () {
      $(".model-number-autocomplete").removeClass("active");
   });

   var cartridge_search_timer,
      cartridge_search_delay = 500;
   var cartridge_search_val = "";

   $("#cartridge_number").on("keyup", function () {
      cartridge_search_val = $(this).val();
      clearTimeout(cartridge_search_timer);

      cartridge_search_timer = setTimeout(function () {
         if (cartridge_search_val.length >= 2) {
            $.ajax({
               url:
                  "/index.php?route=module/ink_toner_finder/autocomplete_cartridge&filter_type=autocomplete&filter_name=" +
                  cartridge_search_val,
               dataType: "json",
               beforeSend: function () {
                  $(".cartridge-number-autocomplete").removeClass("active");
               },
               complete: function () { },
               success: function (response) {
                  //console.log(response);
                  html = "";
                  $.each(response, function (index, value) {
                     html +=
                        '<a href="' + value.url + '" class="item flex items-center">';
                     html += '<div class="details">';
                     html += "<p>";
                     html += value.name;
                     html += "</p>";
                     html += "</div>";
                     html += "</a>";
                  });
                  if (html == "") {
                     html =
                        '<div class="item flex items-center"><div class="details"><p>Sorry! There Were No Matching Results.</p></div></div>';
                  }
                  if (html) {
                     //console.log(html);
                     $(".cartridge-number-autocomplete").html(html);
                     $(".cartridge-number-autocomplete").addClass("active");
                  }
               },
            });
         } else {
            //REMOVE FILTERS
            $(".cartridge-number-autocomplete").removeClass("active");
         }
      }, cartridge_search_delay);
   });

   $("#cartridge_number").blur(function () {
      $(".cartridge-number-autocomplete").removeClass("active");
   });

   $(".remove-item").on("click", function () {
      $(this).parent().remove();
   });

   $(".cart-items-table .add").on("click", function () {
      var cur_val = $(this).parent().find(".qty").val();
      var new_val = parseInt(cur_val) + 1;

      //console.log(new_val)

      $(this).parent().find(".qty").val(new_val);
   });

   $(".cart-items-table .subtract").on("click", function () {
      var cur_val = $(this).parent().find(".qty").val();
      cur_val = parseInt(cur_val);
      if (cur_val == 1) {
         return;
      } else {
         var new_val = cur_val - 1;
         $(this).parent().find(".qty").val(new_val);
      }
   });

   $(".close-modal-icon").on("click", function () {
      $(".modal").iziModal("close");
   });

   $("#login-modal .close-modal-icon").on("click", function () {
      $("#login-modal").iziModal("close");
   });

   $(".show-login").on("click", function (e) {
      e.preventDefault();
      $("#login-modal").iziModal("open");
   });

   if ($(".checkout.user-logged-out").length > 0) {
      $("#login-modal").iziModal("open");
   }

   $("#notify-modal .close-modal-icon").on("click", function () {
      $("#notify-modal").iziModal("close");
   });

   $("#pay-address").on("change", function () {
      if ($(this).is(":checked")) {
         $(".payment-address").slideUp(300);
      } else {
         $(".payment-address").slideDown(300);
      }
   });

   if ($(".compare").length > 0) {
      if ($(window).width() <= 660) {
         $(".product-compare-row .item:first-child").remove();
      }
   }

   $(".filter-toggle").on("click", function (e) {
      e.preventDefault();
      $(".category-filters").addClass("active");
      $(".under-filter-drop").addClass("active");
      $("body").addClass("noscroll");
      $("html").addClass("noscroll");
   });

   $(".filter_link.all_filters").on("click", function (e) {
      e.preventDefault();
      $(".category-filters").addClass("active");
      $(".under-filter-drop").addClass("active");
      $("body").addClass("noscroll");
      $("html").addClass("noscroll");
   });

   $(".sort-toggle").on("click", function (e) {
      e.preventDefault();
      $(".mobile-sortby").addClass("active");
   });

   $(".close-category").on("click", function (e) {
      e.preventDefault();
      $(".category-filters").removeClass("active");
      $(".under-filter-drop").removeClass("active");
      $("body").removeClass("noscroll");
      $("html").removeClass("noscroll");
   });
   $(".under-filter-drop").on("click", function () {
      $(".category-filters").removeClass("active");
      $(this).removeClass("active");
      $("body").removeClass("noscroll");
      $("html").removeClass("noscroll");
   });

   $(".close-sortby").on("click", function (e) {
      e.preventDefault();
      $(".mobile-sortby").removeClass("active");
   });

   if ($(".checkout").length > 0) {
      if ($(window).width() > 1024) {
         var new_height = $(".checkout-steps").height();
         $(".checkout .checkout-review").parent().height(new_height);
      }
   }

   var cart_review_wp = new Waypoint({
      element: $(".footer"),
      handler: function (direction) {
         if (direction == "down") {
            $(".checkout-review").addClass("bottom");
         }
         if (direction == "up") {
            $(".checkout-review").removeClass("bottom");
         }
      },
      offset: "90%",
   });

   $(".deal-brand-trigger").on("click", function (e) {
      e.preventDefault();
      $(".brand-link-filters").toggleClass("active");
   });

   $('button[onclick^="Math.abs"]')
      .removeAttr("onclick")
      .addClass("out-of-stock btn-disabled");

   $('a[onclick^="Math.abs"]')
      .attr("onclick", "event.preventDefault()")
      .addClass("out-of-stock btn-disabled");

   $(".out-of-stock .fa-shopping-cart").remove();

   var resizePopup = function () {
      $(".ui.popup").css("max-height", $(window).height());
   };

   $(window).resize(function (e) {
      resizePopup();
   });
   $(".tooltipped").popup({
      onShow: function () {
         resizePopup();
      },
   });

   $(".product-family.page .menu .item").tab();
});
var acc = document.getElementsByClassName("accordion");
var allpanel = document.getElementsByClassName("panel");
var i;

for (i = 0; i < acc.length; i++) {
   acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      for (j = 0; j < allpanel.length; j++) {
         allpanel[j].style.display = "none";
      }
      if (panel.style.display === "none") {
         panel.style.display = "block";
      } else {
         panel.style.display = "block";
      }
   });
}

var accd = document.getElementsByClassName("accordion11");
var i;

for (i = 0; i < accd.length; i++) {
   accd[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel11 = this.nextElementSibling;

      // $(".panel11").css('display','none');
      if (panel11.style.display === "block") {
         panel11.style.display = "none";
      } else {
         panel11.style.display = "block";
      }
   });
}

function openCity(evt, cityName) {
   var i, tabcontent, tablinks;
   tabcontent = document.getElementsByClassName("tabcontent");
   for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
   }
   tablinks = document.getElementsByClassName("tablinks");
   for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
   }
   document.getElementById(cityName).style.display = "block";
   evt.currentTarget.className += " active";
}

function myFunction() {
   document.getElementById("myDropdown").classList.toggle("show");
}
$(".account_div .dropdown .my_account").click(function (e) {
   e.preventDefault();
   myFunction();
});
$(".account_div .dropdown .my_account img").click(function (e) {
   e.preventDefault();
   myFunction();
});

function myFunctionDeals() {
   document.getElementById("my0rderTrackingDropdown").classList.toggle("show");
}
$(".account_div .dropdown .order_tracking").click(function (e) {
   e.preventDefault();
   myFunctionDeals();
});
$(".account_div .dropdown .order_tracking img").click(function (e) {
   e.preventDefault();
   myFunctionDeals();
});

// Close the dropdown if the user clicks outside of it
window.onclick = function (event) {
   if (
      !(event.target instanceof Element) ||
      !event.target.matches(".my_account")
   ) {
      var dropdowns = document.getElementsByClassName("dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
         var openDropdown = dropdowns[i];
         if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
         }
      }
   }
   if (
      !(event.target instanceof Element) ||
      !event.target.matches(".order_tracking")
   ) {
      var dropdowns = document.getElementsByClassName(
         "order-tracking-dropdown-content",
      );
      var i;
      for (i = 0; i < dropdowns.length; i++) {
         var openDropdown = dropdowns[i];
         if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
         }
      }
   }
};
